import { Point, Sprite } from "pixi.js";

export function scaleSprite(
  sprite: Sprite,
  targetWidth: number,
  targetHeight: number
) {
  const bgSize = { x: targetWidth, y: targetHeight };
  const sp = { x: sprite.texture.width, y: sprite.texture.height };
  const winratio = bgSize.x / bgSize.y;
  const spratio = sp.x / sp.y;
  let scale = 1;
  let pos = new Point(0, 0);
  if (winratio > spratio) {
    //photo is wider than background
    scale = bgSize.x / sp.x;
    pos.y = -(sp.y * scale - bgSize.y) / 2;
  } else {
    //photo is taller than background
    scale = bgSize.y / sp.y;
    pos.x = -(sp.x * scale - bgSize.x) / 2;
  }
  return { scale, pos };
}
